import { render } from "./S620_TreuhandEinstellungen.vue?vue&type=template&id=583ba546&ts=true"
import script from "./S620_TreuhandEinstellungen.vue?vue&type=script&lang=ts"
export * from "./S620_TreuhandEinstellungen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__